import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import Customer from './pages/Customer';
import CustomerHello from './pages/CustomerHello';
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<CustomerHello />} />
        <Route path="/customer/:deviceId" element={<Customer />} />
        <Route path="/customer" element={<Customer />} />
      </Routes>
    </Router>
  );
}

export default App;
